module.exports = __webpack_public_path__ + "img/image4.928cdaa3.png";